import Duck from 'custom-redux-ducks-ts'

export const ads = new Duck('ads', 'eduprivada')
